document.addEventListener('DOMContentLoaded', function () {
  const invoiceBtn = document.querySelector('.invoice-btn');
  const productForm = document.querySelector('form[action="/cart/add"]');
  const purchaseTypeInput = document.getElementById('purchase-type');

  if (!invoiceBtn || !productForm || !purchaseTypeInput) return;

  invoiceBtn.addEventListener('click', function (e) {
    e.preventDefault();

    // ✅ Mark as Invoice purchase
    purchaseTypeInput.value = 'Invoice';

    const formData = new FormData(productForm);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(() => {
      // Optional: reset value so normal ATC stays clean
      purchaseTypeInput.value = '';

      // ✅ Redirect to your custom cart
      window.location.href = '/pages/cart-new';
    })
    .catch(error => {
      console.error('Add to cart failed:', error);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const isInvoice = params.get('invoice') === 'true';
  if (!isInvoice) return;

  // Observe DOM changes (dynamic buttons)
  const observer = new MutationObserver(() => {
    const checkoutBtn = document.querySelector(
      'button[name="checkout"], .cart-submit-button, a[href*="/checkout"]'
    );
    if (checkoutBtn) {
      checkoutBtn.textContent = 'Proceed To Checkout with invoice';
      // Stop observing once changed
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Optional: clean URL so ?invoice=true disappears
  window.history.replaceState({}, '', '/cart');
});
